import {
  AlertOutlined,
  ApartmentOutlined,
  ApiOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BarcodeOutlined,
  BellOutlined,
  BlockOutlined,
  BookOutlined,
  BoxPlotOutlined,
  BranchesOutlined,
  BugOutlined,
  BuildOutlined,
  BulbOutlined,
  CalendarOutlined,
  CarOutlined,
  CarryOutOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloudOutlined,
  ClusterOutlined,
  CodeOutlined,
  CommentOutlined,
  CompassOutlined,
  ContactsOutlined,
  ContainerOutlined,
  ControlOutlined,
  CopyOutlined,
  CrownOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeploymentUnitOutlined,
  DisconnectOutlined,
  DollarOutlined,
  DownOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FireOutlined,
  FlagOutlined,
  FunnelPlotOutlined,
  GiftOutlined,
  GlobalOutlined,
  GoldOutlined,
  GroupOutlined,
  HddOutlined,
  HeartOutlined,
  HighlightOutlined,
  HomeOutlined,
  InboxOutlined,
  InsuranceOutlined,
  InteractionOutlined,
  LayoutOutlined,
  LikeOutlined,
  LinkOutlined,
  LockOutlined,
  MailOutlined,
  MessageOutlined,
  NotificationOutlined,
  PhoneOutlined,
  PieChartOutlined,
  ProfileOutlined,
  PushpinOutlined,
  ReadOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  SearchOutlined,
  SettingOutlined,
  ShopOutlined,
  SolutionOutlined,
  StarOutlined,
  StopOutlined,
  TagsOutlined,
  TeamOutlined,
  ToolOutlined,
  TrophyOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { Button, Input, Popover, Space, Tooltip, Typography } from 'antd';
import React from 'react';
import Empty from '@/components/QuietEmpty';

type IconComponent = React.ComponentType<{ style?: React.CSSProperties }>;

type AppIconOption = {
  value: string;
  label: string;
  keywords: string[];
  component: IconComponent;
};

export const APP_ICON_OPTIONS: AppIconOption[] = [
  {
    value: 'GlobalOutlined',
    label: '全球 / 官网',
    keywords: ['global', 'website', 'web'],
    component: GlobalOutlined,
  },
  {
    value: 'NotificationOutlined',
    label: '活动 / 通知',
    keywords: ['event', 'notification', 'campaign'],
    component: NotificationOutlined,
  },
  {
    value: 'BellOutlined',
    label: '提醒 / 消息',
    keywords: ['bell', 'notice', 'alert'],
    component: BellOutlined,
  },
  {
    value: 'AlertOutlined',
    label: '预警 / 风险',
    keywords: ['alert', 'warning', 'risk'],
    component: AlertOutlined,
  },
  {
    value: 'ApiOutlined',
    label: '接口 / 集成',
    keywords: ['api', 'integration'],
    component: ApiOutlined,
  },
  {
    value: 'BranchesOutlined',
    label: '渠道 / 推荐',
    keywords: ['share', 'partner', 'referral'],
    component: BranchesOutlined,
  },
  {
    value: 'TeamOutlined',
    label: '团队 / 客户',
    keywords: ['team', 'customer', 'people'],
    component: TeamOutlined,
  },
  {
    value: 'ContactsOutlined',
    label: '联系人',
    keywords: ['contacts', 'contact', 'people'],
    component: ContactsOutlined,
  },
  {
    value: 'GroupOutlined',
    label: '分组 / 组织',
    keywords: ['group', 'organization'],
    component: GroupOutlined,
  },
  {
    value: 'PhoneOutlined',
    label: '电话',
    keywords: ['phone', 'call'],
    component: PhoneOutlined,
  },
  {
    value: 'MessageOutlined',
    label: '消息 / 社媒',
    keywords: ['message', 'chat', 'social'],
    component: MessageOutlined,
  },
  {
    value: 'CommentOutlined',
    label: '评论 / 会话',
    keywords: ['comment', 'conversation'],
    component: CommentOutlined,
  },
  {
    value: 'MailOutlined',
    label: '邮件',
    keywords: ['mail', 'email'],
    component: MailOutlined,
  },
  {
    value: 'AppstoreOutlined',
    label: '应用 / 软件',
    keywords: ['app', 'software', 'grid'],
    component: AppstoreOutlined,
  },
  {
    value: 'DashboardOutlined',
    label: '看板 / 仪表盘',
    keywords: ['dashboard', 'board'],
    component: DashboardOutlined,
  },
  {
    value: 'ApartmentOutlined',
    label: '结构 / 分类',
    keywords: ['structure', 'category', 'tree'],
    component: ApartmentOutlined,
  },
  {
    value: 'ClusterOutlined',
    label: '分组 / 层级',
    keywords: ['cluster', 'group', 'hierarchy'],
    component: ClusterOutlined,
  },
  {
    value: 'DeploymentUnitOutlined',
    label: '流程 / 节点',
    keywords: ['deployment', 'flow', 'pipeline'],
    component: DeploymentUnitOutlined,
  },
  {
    value: 'ControlOutlined',
    label: '控制 / 开关',
    keywords: ['control', 'toggle'],
    component: ControlOutlined,
  },
  {
    value: 'BlockOutlined',
    label: '模块 / 区块',
    keywords: ['block', 'module'],
    component: BlockOutlined,
  },
  {
    value: 'TagsOutlined',
    label: '标签 / 商品',
    keywords: ['tag', 'product', 'label'],
    component: TagsOutlined,
  },
  {
    value: 'BarcodeOutlined',
    label: '编码 / 条码',
    keywords: ['barcode', 'code'],
    component: BarcodeOutlined,
  },
  {
    value: 'CopyOutlined',
    label: '复制 / 模板',
    keywords: ['copy', 'template'],
    component: CopyOutlined,
  },
  {
    value: 'ToolOutlined',
    label: '工具 / 服务',
    keywords: ['tool', 'service'],
    component: ToolOutlined,
  },
  {
    value: 'BuildOutlined',
    label: '实施 / 交付',
    keywords: ['build', 'implementation', 'delivery'],
    component: BuildOutlined,
  },
  {
    value: 'ContainerOutlined',
    label: '容器 / 资料',
    keywords: ['container', 'record'],
    component: ContainerOutlined,
  },
  {
    value: 'ShopOutlined',
    label: '商业 / 店铺',
    keywords: ['shop', 'business'],
    component: ShopOutlined,
  },
  {
    value: 'BankOutlined',
    label: '企业 / 机构',
    keywords: ['bank', 'company', 'organization'],
    component: BankOutlined,
  },
  {
    value: 'HomeOutlined',
    label: '主页 / 门户',
    keywords: ['home', 'portal'],
    component: HomeOutlined,
  },
  {
    value: 'FlagOutlined',
    label: '里程碑 / 阶段',
    keywords: ['flag', 'milestone', 'stage'],
    component: FlagOutlined,
  },
  {
    value: 'CarryOutOutlined',
    label: '执行 / 计划',
    keywords: ['carry', 'execute', 'todo'],
    component: CarryOutOutlined,
  },
  {
    value: 'SearchOutlined',
    label: '搜索 / 发现',
    keywords: ['search', 'discovery'],
    component: SearchOutlined,
  },
  {
    value: 'FileSearchOutlined',
    label: '调研 / 线索',
    keywords: ['file search', 'research', 'lead'],
    component: FileSearchOutlined,
  },
  {
    value: 'FunnelPlotOutlined',
    label: '筛选 / 条件',
    keywords: ['filter', 'condition'],
    component: FunnelPlotOutlined,
  },
  {
    value: 'AuditOutlined',
    label: '审核 / 复盘',
    keywords: ['audit', 'review', 'approval'],
    component: AuditOutlined,
  },
  {
    value: 'FileTextOutlined',
    label: '方案 / 文档',
    keywords: ['file', 'proposal', 'document'],
    component: FileTextOutlined,
  },
  {
    value: 'FileDoneOutlined',
    label: '已确认 / 已归档',
    keywords: ['done', 'archive', 'confirmed'],
    component: FileDoneOutlined,
  },
  {
    value: 'ProfileOutlined',
    label: '档案 / 配置',
    keywords: ['profile', 'config'],
    component: ProfileOutlined,
  },
  {
    value: 'BookOutlined',
    label: '知识 / 手册',
    keywords: ['book', 'guide'],
    component: BookOutlined,
  },
  {
    value: 'ReadOutlined',
    label: '阅读 / 学习',
    keywords: ['read', 'learn'],
    component: ReadOutlined,
  },
  {
    value: 'InboxOutlined',
    label: '收件 / 线索池',
    keywords: ['inbox', 'pool'],
    component: InboxOutlined,
  },
  {
    value: 'DollarOutlined',
    label: '价格 / 商务',
    keywords: ['dollar', 'price', 'deal'],
    component: DollarOutlined,
  },
  {
    value: 'BoxPlotOutlined',
    label: '商机 / 漏斗',
    keywords: ['boxplot', 'opportunity', 'funnel'],
    component: BoxPlotOutlined,
  },
  {
    value: 'WalletOutlined',
    label: '付款 / 收益',
    keywords: ['wallet', 'payment', 'money'],
    component: WalletOutlined,
  },
  {
    value: 'CheckCircleOutlined',
    label: '成功 / 完成',
    keywords: ['success', 'done', 'won'],
    component: CheckCircleOutlined,
  },
  {
    value: 'TrophyOutlined',
    label: '赢单 / 胜利',
    keywords: ['trophy', 'win'],
    component: TrophyOutlined,
  },
  {
    value: 'StopOutlined',
    label: '终止 / 失败',
    keywords: ['stop', 'lost', 'closed'],
    component: StopOutlined,
  },
  {
    value: 'DisconnectOutlined',
    label: '断开 / 流失',
    keywords: ['disconnect', 'lost', 'break'],
    component: DisconnectOutlined,
  },
  {
    value: 'LockOutlined',
    label: '锁定 / 安全',
    keywords: ['lock', 'security'],
    component: LockOutlined,
  },
  {
    value: 'InsuranceOutlined',
    label: '保障 / 合规',
    keywords: ['insurance', 'safety', 'compliance'],
    component: InsuranceOutlined,
  },
  {
    value: 'ClockCircleOutlined',
    label: '时间 / 排期',
    keywords: ['clock', 'time', 'schedule'],
    component: ClockCircleOutlined,
  },
  {
    value: 'CalendarOutlined',
    label: '日程 / 计划',
    keywords: ['calendar', 'plan'],
    component: CalendarOutlined,
  },
  {
    value: 'RocketOutlined',
    label: '启动 / 增长',
    keywords: ['rocket', 'launch', 'growth'],
    component: RocketOutlined,
  },
  {
    value: 'FireOutlined',
    label: '热点 / 高热度',
    keywords: ['fire', 'hot', 'priority'],
    component: FireOutlined,
  },
  {
    value: 'BulbOutlined',
    label: '创意 / 机会',
    keywords: ['bulb', 'idea', 'opportunity'],
    component: BulbOutlined,
  },
  {
    value: 'LinkOutlined',
    label: '关联 / 合作',
    keywords: ['link', 'connection', 'partner'],
    component: LinkOutlined,
  },
  {
    value: 'SolutionOutlined',
    label: '解决方案',
    keywords: ['solution', 'plan'],
    component: SolutionOutlined,
  },
  {
    value: 'InteractionOutlined',
    label: '互动 / 协同',
    keywords: ['interaction', 'collaboration'],
    component: InteractionOutlined,
  },
  {
    value: 'SettingOutlined',
    label: '设置 / 配置',
    keywords: ['setting', 'config'],
    component: SettingOutlined,
  },
  {
    value: 'CodeOutlined',
    label: '代码 / 规则',
    keywords: ['code', 'rule'],
    component: CodeOutlined,
  },
  {
    value: 'LayoutOutlined',
    label: '布局 / 结构',
    keywords: ['layout', 'structure'],
    component: LayoutOutlined,
  },
  {
    value: 'SafetyCertificateOutlined',
    label: '合规 / 权限',
    keywords: ['safety', 'permission', 'compliance'],
    component: SafetyCertificateOutlined,
  },
  {
    value: 'DatabaseOutlined',
    label: '数据 / 存储',
    keywords: ['database', 'data'],
    component: DatabaseOutlined,
  },
  {
    value: 'PieChartOutlined',
    label: '分析 / 统计',
    keywords: ['chart', 'analysis', 'stats'],
    component: PieChartOutlined,
  },
  {
    value: 'CloudOutlined',
    label: '云端 / 平台',
    keywords: ['cloud', 'platform'],
    component: CloudOutlined,
  },
  {
    value: 'GoldOutlined',
    label: '高价值 / 重点',
    keywords: ['gold', 'vip', 'key'],
    component: GoldOutlined,
  },
  {
    value: 'CrownOutlined',
    label: '高级 / 核心',
    keywords: ['crown', 'premium'],
    component: CrownOutlined,
  },
  {
    value: 'EnvironmentOutlined',
    label: '地区 / 位置',
    keywords: ['location', 'area', 'region'],
    component: EnvironmentOutlined,
  },
  {
    value: 'CompassOutlined',
    label: '方向 / 导航',
    keywords: ['compass', 'direction'],
    component: CompassOutlined,
  },
  {
    value: 'PushpinOutlined',
    label: '标记 / 定位',
    keywords: ['pin', 'mark'],
    component: PushpinOutlined,
  },
  {
    value: 'CustomerServiceOutlined',
    label: '支持 / 服务',
    keywords: ['support', 'service'],
    component: CustomerServiceOutlined,
  },
  {
    value: 'ExperimentOutlined',
    label: '实验 / 测试',
    keywords: ['experiment', 'test'],
    component: ExperimentOutlined,
  },
  {
    value: 'BugOutlined',
    label: '问题 / 缺陷',
    keywords: ['bug', 'issue'],
    component: BugOutlined,
  },
  {
    value: 'LikeOutlined',
    label: '偏好 / 点赞',
    keywords: ['like', 'preference'],
    component: LikeOutlined,
  },
  {
    value: 'HddOutlined',
    label: '资源 / 容量',
    keywords: ['storage', 'capacity'],
    component: HddOutlined,
  },
  {
    value: 'HeartOutlined',
    label: '偏好 / 关注',
    keywords: ['heart', 'favorite'],
    component: HeartOutlined,
  },
  {
    value: 'HighlightOutlined',
    label: '重点 / 说明',
    keywords: ['highlight', 'note'],
    component: HighlightOutlined,
  },
  {
    value: 'StarOutlined',
    label: '星标 / 优先',
    keywords: ['star', 'priority'],
    component: StarOutlined,
  },
  {
    value: 'CarOutlined',
    label: '拜访 / 外勤',
    keywords: ['car', 'visit', 'field'],
    component: CarOutlined,
  },
  {
    value: 'GiftOutlined',
    label: '权益 / 福利',
    keywords: ['gift', 'benefit'],
    component: GiftOutlined,
  },
];

const APP_ICON_MAP = Object.fromEntries(
  APP_ICON_OPTIONS.map((item) => [item.value, item.component]),
) as Record<string, IconComponent>;

export function renderAppIcon(icon?: string, size = 16) {
  if (!icon) {
    return null;
  }
  const IconComponent = APP_ICON_MAP[icon];
  if (!IconComponent) {
    return null;
  }
  return (
    <IconComponent
      style={{ fontSize: size, lineHeight: 1, color: 'currentColor' }}
    />
  );
}

function AppIconGrid({
  value,
  onChange,
}: {
  value?: string;
  onChange?: (value?: string) => void;
}) {
  const [keyword, setKeyword] = React.useState('');

  const filteredOptions = React.useMemo(() => {
    const normalizedKeyword = keyword.trim().toLowerCase();
    if (!normalizedKeyword) {
      return APP_ICON_OPTIONS;
    }

    return APP_ICON_OPTIONS.filter((item) =>
      [item.value, item.label, ...item.keywords]
        .join(' ')
        .toLowerCase()
        .includes(normalizedKeyword),
    );
  }, [keyword]);

  return (
    <div style={{ width: 520 }}>
      <Input
        allowClear
        size="middle"
        placeholder="搜索图标名称"
        value={keyword}
        onChange={(event) => setKeyword(event.target.value)}
        style={{ marginBottom: 12 }}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(40px, 1fr))',
          gap: 8,
          maxHeight: 320,
          overflowY: 'auto',
          paddingRight: 4,
        }}
      >
        {filteredOptions.length ? (
          filteredOptions.map((item) => {
            const selected = value === item.value;
            return (
              <Tooltip key={item.value} title={`${item.label} · ${item.value}`}>
                <Button
                  type="text"
                  aria-label={item.label}
                  onClick={() => onChange?.(item.value)}
                  style={{
                    width: 40,
                    height: 40,
                    padding: 0,
                    borderRadius: 10,
                    border: selected
                      ? '1px solid var(--ant-color-primary)'
                      : '1px solid var(--ant-color-border-secondary)',
                    background: selected
                      ? 'var(--ant-color-primary-bg)'
                      : 'var(--ant-color-bg-container)',
                    color: selected
                      ? 'var(--ant-color-primary)'
                      : 'var(--ant-color-text)',
                  }}
                  icon={React.createElement(item.component, {
                    style: { fontSize: 18 },
                  })}
                />
              </Tooltip>
            );
          })
        ) : (
          <div style={{ gridColumn: '1 / -1', padding: '20px 0' }}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} />
          </div>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginTop: 8,
        }}
      >
        <Button type="link" size="small" onClick={() => onChange?.(undefined)}>
          清空图标
        </Button>
      </div>
    </div>
  );
}

export function AppIconSelect({
  value,
  onChange,
  placeholder = '点击选择图标',
}: {
  value?: string;
  onChange?: (value?: string) => void;
  placeholder?: string;
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open}
      onOpenChange={setOpen}
      content={
        <AppIconGrid
          value={value}
          onChange={(nextValue) => {
            onChange?.(nextValue);
            setOpen(false);
          }}
        />
      }
    >
      <Button
        block
        type="default"
        style={{
          height: 32,
          justifyContent: 'space-between',
          paddingInline: 11,
          borderRadius: 6,
        }}
      >
        <Space size={10}>
          {value ? (
            <span
              style={{
                display: 'inline-flex',
                width: 18,
                height: 18,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {renderAppIcon(value, 16)}
            </span>
          ) : (
            <Typography.Text type="secondary" style={{ lineHeight: '20px' }}>
              {placeholder}
            </Typography.Text>
          )}
        </Space>
        <DownOutlined
          style={{ color: 'var(--ant-color-text-quaternary)', fontSize: 12 }}
        />
      </Button>
    </Popover>
  );
}
